var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.topage(item)}}},[_vm._v(_vm._s(item.title))])])}),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('span',[_vm._v("Copyright © 2024-2026 医疗信息化有限公司 版权所有")])])
}]

export { render, staticRenderFns }